import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sponsors',
  templateUrl: './sponsors.component.html',
  styleUrls: ['./sponsors.component.css']
})
export class SponsorsComponent implements OnInit {

  public sponsorlist=[
    "./../../assets/images/ABBOTT.jpg",
    "./../../assets/images/AZ_CMYK_H_POS.JPG",
    "./../../assets/images/BayerLogo.png",
    "./../../assets/images/BI.jpg",
    "./../../assets/images/ELPEN.jpg",
    "./../../assets/images/GE.png",
    "./../../assets/images/GENESIS.jpg",
    "./../../assets/images/Medical_Dynamics_Logo_2.jpg",
    "./../../assets/images/Medtronic.jpg",
    "./../../assets/images/Menarini.jpg",
    "./../../assets/images/MERCK.jpg",
    "./../../assets/images/Pfizer.jpg",
    "./../../assets/images/Roche.jpg",
    "./../../assets/images/Servier.png",
    "./../../assets/images/uni-pharma.jpg",
    "./../../assets/images/WinMedica.jpg",
  ];


  constructor() { }

  ngOnInit(): void {
  }

}
